import React, { useState } from "react";
import { auth, db } from "../firebase";
import { addDoc, collection } from "firebase/firestore";
import { Button, TextInput } from "@mantine/core";
import { useIntl } from "react-intl";

interface SendMessageProps {
  userId: string;
  chatId: string;
}
const SendMessage = (props: SendMessageProps) => {
  const intl = useIntl();

  const [message, setMessage] = useState("");

  const sendMessage = async () => {
    if (message.trim() === "") {
      alert("Enter valid message");
      return;
    }
    if (!auth.currentUser) return;
    await addDoc(collection(db, "messages"), {
      text: message,
      name: auth.currentUser.displayName,
      avatar: auth.currentUser.photoURL,
      createdAt: new Date().toISOString(),
      senderId: auth.currentUser.uid,
      recipientId: props.userId,
      chatId: props.chatId,
    });
    setMessage("");
  };

  const handleInputKeyDown = (event: any) => {
    if (event.key === "Enter") {
      sendMessage(); // Trigger button action when Enter is pressed
    }
  };

  return (
    <div className="send-message-form">
      <TextInput
        id="messageInput"
        name="messageInput"
        className="form-input__input"
        placeholder={intl.formatMessage({ id: "chatwindow.typeMessage" })}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={handleInputKeyDown}
        maxLength={1000}
      />
      <Button className="form-input__button" onClick={sendMessage}>
        {intl.formatMessage({ id: "button.send" })}
      </Button>
    </div>
  );
};

export default SendMessage;
